import styled from "styled-components";

export const Div = styled.div`
	.outerCon {
		position: relative;
		padding-bottom: 56.25%; /* 16:9 */
		height: 0;
	}
	.outerCon iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	.description {
	}
	.outerCon {
		min-height: 6.25rem;
		max-height: 14.75rem;
	}
`;
export const VideoURLLink = styled.a`
	color: rgb(44, 118, 170);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	text-decoration: underline;
`;
